import * as React from "react";
const IconHotelSign = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M57.8 60h-4.3V4h4.3c.6 0 1-.4 1-1s-.4-1-1-1H47.3c-.6 0-1 .4-1 1s.4 1 1 1h4.3v5.9h-14V7c0-2.8-2.2-5-5-5H10.2c-2.8 0-5 2.2-5 5v50c0 2.8 2.2 5 5 5h22.4c2.8 0 5-2.2 5-5v-2.9h13.9V60h-4.3c-.6 0-1 .4-1 1s.4 1 1 1h10.5c.6 0 1-.4 1-1s-.4-1-.9-1m-22.2-3c0 1.7-1.3 3-3 3H10.2c-1.7 0-3-1.3-3-3V7c0-1.7 1.3-3 3-3h22.4c1.7 0 3 1.3 3 3zm2-4.9V11.9h13.9v40.2z" />
    <path d="M27.3 11H15.5c-.6 0-1 .4-1 1s.4 1 1 1h11.7c.6 0 1-.4 1-1s-.4-1-.9-1M27.3 24H15.5c-.6 0-1 .4-1 1s.4 1 1 1h11.7c.6 0 1-.4 1-1s-.4-1-.9-1M27.3 37.1H15.5c-.6 0-1 .4-1 1s.4 1 1 1h11.7c.6 0 1-.4 1-1s-.4-1-.9-1M27.3 50.2H15.5c-.6 0-1 .4-1 1s.4 1 1 1h11.7c.6 0 1-.4 1-1s-.4-1-.9-1" />
  </svg>
);
export default IconHotelSign;
